// removed by extract-text-webpack-plugin
module.exports = {"discount":"discount__discount-2HXge","discountGray":"discount__discountGray-3MgTt","discountLabel":"discount__discountLabel-1qzuP","discountBlock":"discount__discountBlock-2b1LP","tooltipWrapper":"discount__tooltipWrapper-cwEbV content__tooltipWrapper-2FC7Y","tooltip":"discount__tooltip-1EHVn content__tooltip-2qaaU blocks__tooltip-20lA1 blocks__leftToRight-v7Jyh blocks__isShown--23z3","count":"discount__count-1eDlB","noDiscountTooltip":"discount__noDiscountTooltip-2inSx"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/additional-parameters/content/discount/discount.css
// module id = 798
// module chunks = 0